import {gql, useQuery} from '@apollo/client';
import {pickLocalizedText} from '../../../../../utils/i18nText';

/** 客诉一级分类字典项（与 Kotlin ComplaintCategoryOptionType 对齐：code + 可扩展多语言文案 texts） */
export interface ComplaintCategoryOption {
    code: string;
    displayOrder?: number;
    texts: {lang: string; text: string}[];
}

export const GET_COMPLAINT_CATEGORY_LIST = gql`
    query GetComplaintCategoryList {
        getComplaintCategoryList {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
    }
`;

interface GetComplaintCategoryListResponse {
    getComplaintCategoryList: ComplaintCategoryOption[];
}

/** 客诉一级分类字典（cache-first）。文案单一来源为后端 ComplaintCategory enum，前端不再硬编码 */
export const useComplaintCategories = () => {
    const {data, loading} = useQuery<GetComplaintCategoryListResponse>(GET_COMPLAINT_CATEGORY_LIST, {
        fetchPolicy: 'cache-first',
    });
    return {
        options: data?.getComplaintCategoryList ?? [],
        loading,
    };
};

/** 按当前 locale 从字典项 texts 中选展示文案 */
export const pickCategoryText = (
    option: ComplaintCategoryOption | undefined,
    locale: string,
): string => {
    if (!option) return '';
    return pickLocalizedText(option.texts, locale);
};
